import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { Demonstracao } from '@/features/design-system/componentes/Demonstracao';

const busca = z.object({
  busca: z.string().optional(),
  cursor: z.string().optional(),
  grupo: z.string().optional(),
  situacao: z.string().optional(),
});

/** `/_ds`: aprovação visual do design system (spec 001, CA-10). Só em desenvolvimento. */
export const Route = createFileRoute('/_ds')({
  validateSearch: busca,
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: PaginaDoDesignSystem,
});

function PaginaDoDesignSystem() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Demonstracao
      busca={valores}
      aoMudarBusca={(mudanca) => {
        void navigate({ search: (atual) => ({ ...atual, ...mudanca }), replace: true });
      }}
    />
  );
}
